export default __webpack_public_path__ + "static/media/sample_coupon.46920dbb.png";